import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { isValidEmail, isValidPassword } from '../utils/validation'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const { login } = useAuth()
  const navigate = useNavigate()

  // 即时校验：全部通过时按钮高亮可用
  const emailOk = isValidEmail(email)
  const pwdOk = isValidPassword(password)
  const canSubmit = emailOk && pwdOk && !submitting

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    if (!emailOk || !pwdOk) return
    setSubmitting(true)
    try {
      await login(email, password)
      navigate('/')
    } catch (err) {
      setError(err.response?.data?.error || err.message || '登录失败，请检查邮箱和密码')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="mx-auto mt-10 flex max-w-md flex-col items-center">
      <div className="w-full rounded-[2rem] border border-blush/30 bg-white p-8 shadow-card">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-blush-light text-3xl">🍡</div>
          <h1 className="text-2xl font-bold text-cocoa">欢迎回到豆田造物</h1>
          <p className="mt-1 text-sm text-cocoa-light">登录后继续生成甜甜的拼豆图纸~</p>
        </div>

        {error && (
          <div className="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-2 text-sm text-red-600">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-cocoa">邮箱</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={`form-input ${email && !emailOk ? 'border-red-300' : ''}`}
              placeholder="you@example.com"
            />
            {email && !emailOk && (
              <p className="mt-1 text-xs text-red-500">邮箱格式不正确</p>
            )}
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-cocoa">密码</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              className={`form-input ${password && !pwdOk ? 'border-red-300' : ''}`}
              placeholder="••••••"
            />
            {password && !pwdOk && (
              <p className="mt-1 text-xs text-red-500">密码至少 6 位</p>
            )}
          </div>
          <button
            type="submit"
            disabled={!canSubmit}
            className={`btn-primary w-full transition ${
              canSubmit ? 'shadow-md' : 'cursor-not-allowed opacity-40'
            }`}
          >
            {submitting ? '登录中…' : '登录'}
          </button>
        </form>

        <p className="mt-5 text-center text-sm text-cocoa-light">
          还没有账号？{' '}
          <Link to="/register" className="font-semibold text-blush-dark hover:underline">
            立即注册
          </Link>
        </p>
      </div>
    </div>
  )
}
